<template>
  <div class="shop-order">
    <div class="shop-order-nav">
      <Nav
        :list="[...$optionsData.defaultAll, ...$optionsData.orderMenuListSlice]"
        :activeValue.sync="activeValue"
        @on-success="onNavChange"
        class="nav-container"
      ></Nav>
    </div>
    <TablePage ref="list" @page-change="pageHandler" :total="total">
      <table>
        <tr class="t-header">
          <th class="t-g">商品信息 Commodity Information</th>
          <th class="t-s">收货信息 Address</th>
          <th class="t-m">金额 Amount</th>
          <th class="t-o">操作 Operation</th>
        </tr>
        <div v-for="item in orderList" :key="item.id" class="t-order">
          <tr class="t-order-info fl-align-center">
            <th class="primary-text" style="margin-left:30px">
              {{ item.orderTime }}
            </th>
            <th class="primary-text">订单编号 Order number：{{ item.orderNo }}</th>
            <th class="primary-text">
              {{ item.entityName }}
            </th>
            <th class="primary-text">
              <span class="tag takeout-tag" v-if="item.orderType == 1">秒杀</span>
              <span class="tag group-tag" v-if="item.orderType == 2">拼团</span>
              <span class="tag takeout-tag" v-if="item.orderType == 3">外卖</span>
              <span class="tag integral-tag" v-if="item.orderType == 4">积分购</span>
              <span>{{ item.statusDesc }}</span>
            </th>
          </tr>
          <tr class="t-order-content">
            <td class="t-g">
              <div class="goods-item" v-for="good in item.goodsList" :key="good.id">
                <div class="good-image">
                  <el-image :src="good.coverImage"></el-image>
                </div>
                <div class="good-info">
                  <p class="primary-text sl-ellipsis">{{ good.name }}</p>
                  <p class="primary-text sl-ellipsis">{{ good.nameEn }}</p>
                  <div class="good-spec">规格：{{ good.spec || "单规格" }}</div>
                  <div class="good-price primary-text">￥{{ good.price }}×{{ good.qty }}</div>
                </div>
              </div>
            </td>
            <td class="t-s primary-text">
              <div class="t-s-d">
                <el-popover width="400" trigger="hover" :disabled="item.takeType == 0">
                  <div>
                    <span>{{ item.consigneeName }}</span
                    >&nbsp;
                    <span>{{ item.consigneeMobile }}</span>
                    <div v-if="item.isRoomEms == 0">{{ item.consigneeArea }} {{ item.consigneeAddress }}</div>
                    <div v-if="item.isRoomEms == 1">酒店房号：{{ item.roomName }}</div>
                  </div>
                  <div slot="reference">
                    <div>{{ item.takeTypeDesc }}</div>
                    <img style="margin:10px auto" v-if="item.takeType == 1" src="@/assets/img/wl.png" alt="" />
                  </div>
                </el-popover>
              </div>
            </td>
            <td class="t-m primary-text">
              <p>￥{{ item.payAmount }}</p>
              <p>分摊优惠：￥{{ item.goodsDecrAmount }}</p>
              <p>奖励金：￥{{ item.bonusDecrAmount }}</p>
            </td>
            <td class="t-o">
              <div class="order-btns">
                <template v-for="(btn, index) in item.btns">
                  <div
                    @click="handleClick(item, btn.funName)"
                    :class="['btn-item', btn.btnType == 'normal' ? 'normal-btn' : 'primary-btn']"
                    :key="index"
                  >
                    <div>
                      <p>{{ btn.chName }}</p>
                      <p>{{ btn.enName }}</p>
                    </div>
                  </div>
                </template>
                <div @click="handleClick(item, 'viewDetails')" :class="['btn-item', 'normal-btn']">
                  <div>
                    <p>查看详情</p>
                    <p>View Details</p>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </div>
      </table>
    </TablePage>
    <ShareDialog title="" v-if="shareVisible" :visible.sync="shareVisible" :shareImg="shareImg" />
  </div>
</template>

<script>
import Nav from "@/components/base/Nav.vue";
import TablePage from "@/components/base/TablePage";
import ShareDialog from "@/components/base/ShareDialog";
import PickUpCodeDialog from "./PickUpCodeDialog";
export default {
  name: "ShopOrder",
  components: { Nav, TablePage, ShareDialog, PickUpCodeDialog },
  props: {
    title: String,
  },
  data() {
    return {
      activeValue: -1,
      orderList: [],
      total: 0,
      orderStateOptions: [],
      shareVisible: false,
      shareImg: "",
    };
  },
  computed: {},
  mounted() {
    this.searchHandler();
    this.orderStateOptions = this.$_.cloneDeep(this.$optionsData.orderStateOptions);
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    onNavChange() {
      this.searchHandler();
    },
    async pageHandler(page, pageSize) {
      const params = {
        orderStatus: this.activeValue == -1 ? "" : this.activeValue,
        page: page,
        pageSize: pageSize,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getOrderCommonList(params);
        this.orderList = list.map((item) => {
          item.total = item.goodsList.reduce((pre, cur) => {
            return pre + cur.qty;
          }, 0);
          item.btns = this.orderStateOptions[item.status].btns || [];
          if (item.status == 3 && item.takeType == 0) {
            item.btns = this.orderStateOptions[item.status].btns1 || [];
          }
          if (item.status == 4) {
            if (item.canInvoice == 1) {
              item.btns[0].hidden = false;
            }
            if (item.invoiceVO && item.invoiceVO.status == 1) {
              //状态 0待受理 1已开票 2已驳回
              item.btns[1].hidden = false;
            }
          }
          item.btns = item.btns.filter((v) => !v.hidden);
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
    getOrderList() {
      api.getOrderCommonList(
        {
          orderStatus: this.data.orderStatus,
          page: this.data.page,
          pageSize: 10,
        },
        (res) => {
          this.formatList(res.data);
        }
      );
    },
    handleClick(item, funName) {
      this[funName](item);
    },
    //取消订单
    cancelOrder(item) {
      this.$confirm("确定取消该订单？", "提示", {
        type: "warning",
        cancelButtonText: "再想想",
        confirmButtonText: "确定取消",
      })
        .then(async () => {
          try {
            await this.$api.cancelOrder({
              orderNo: item.orderNo,
            });
            this.$message.success("取消成功");
            this.searchHandler();
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {});
    },
    //去付款
    payGoods(item) {
      this.$router.push(`/home/pay-way?orderNo=${item.orderNo}&orderType=s`);
    },
    //去分享
    // async toShare(item) {
    //   let { data } = await this.$api.createLink({
    //     content: JSON.stringify({ groupId: item.goodsList[0] && item.goodsList[0].groupId }),
    //   });
    //   const params = {
    //     page: `implant/shareGroup/index`,
    //     scene: data?.shortLink,
    //   };
    //   try {
    //     let { data } = await this.$api.getQrCode(params);
    //     this.shareImg = data;
    //     this.shareVisible = true;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    //查看详情
    viewDetails(item) {
      this.$router.push(`/my-profile/order/detail?orderNo=${item.orderNo}`);
    },

    //进入到小程序订单详情
    async toMiniAppOrderInfo(item) {
      let { data } = await this.$api.createLink({
        content: JSON.stringify({ orderNo: item.orderNo }),
      });
      const params = {
        page: `implant/orders/detail/index`,
        scene: data?.shortLink,
      };
      try {
        let { data } = await this.$api.getQrCode(params);
        this.shareImg = data;
        this.shareVisible = true;
      } catch (error) {
        console.log(error);
      }
    },

    //查看物流
    async checkLogistics({ id }) {
      const params = {
        orderStoreId: id,
      };
      try {
        let { data } = await this.$api.getLogistics(params);
        this.$alert(data.emsNo, "物流单号");
      } catch (error) {
        console.log(error);
      }
    },
    //确认收货
    async confrimGet({ orderNo }) {
      try {
        await this.$api.emsConfirm({
          orderNo,
        });
        this.$message.success("确认收货成功");
        this.searchHandler();
      } catch (error) {
        console.log(error);
      }
    },
    
    //查看订单详情
    async getOrderCommonDetail(orderNo) {
      try {
        let { data } = await this.$api.getOrderCommonDetail({orderNo});
        console.log(data)
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.shop-order {
  .shop-order-nav {
    margin-top: 40px;
    /deep/.channel-nav-item {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      margin-right: 0 !important;
      flex: 1;
    }
  }
}
table {
  width: 100%;
  margin-top: 20px;
  .t-header {
    height: 50px;
    background: #fcfcfc;
    border: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    > th {
      white-space: nowrap;
      flex: none;
    }
  }
  .t-g {
    width: 590px;
  }
  .t-s {
    display: flex;
    justify-content: center;
    text-align: center;
    width: 160px;
  }
  .t-m {
    width: 160px;
    border-right: 1px solid #f0f0f0;
    p {
      text-align: center;
      line-height: 1.5;
    }
  }
  .t-o {
    // width: 160px;
    text-align: center;
    flex: 1;
  }
  .t-order-info {
    height: 50px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    th {
      margin-left: 100px;
    }
  }
}

.t-order-content {
  background: #fcfcfc;
  display: flex;
  border-left: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  td {
    box-sizing: border-box;
  }
  .goods-item {
    display: flex;
    align-items: flex-start;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #f0f0f0;
    border-bottom: 0;
    .good-info {
      flex: 1;
      p {
        width: 400px;
        line-height: 1.3;
      }
      .good-spec {
        margin-top: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }
      .good-price {
        margin-top: 16px;
      }
    }
    .good-image .el-image {
      width: 88px;
      height: 88px;
      display: block;
      margin-left: 32px;
      margin-right: 20px;
    }
  }
  .t-s {
    padding: 30px 20px 0;
    border-right: 1px solid #f0f0f0;
  }
  .t-m {
    padding-top: 30px;
  }
  .t-o {
    flex: 1;
    display: flex;
    justify-content: center;
    padding-top: 30px;
    .btn-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 144px;
      height: 40px;
      cursor: pointer;
      margin-top: 2px;
      div {
        font-size: 14px;
        font-weight: 400;
        text-align: center;
      }
      &.normal-btn {
        background: #fff;
        color: #333333;
      }
      &.primary-btn {
        background: #333333;
        color: #ffffff;
      }
    }
  }
}
.t-order:last-child .t-g .goods-item:last-child {
  border-bottom: 1px solid #f0f0f0;
}
.tag {
  display: inline-block;
  height: 20px !important;
  line-height: 20px !important;
  border: 1px solid #dbe3ff;
  border-radius: 4px;
  padding: 0 17px !important;
  font-size: 12px;
  margin-right: 20px;
}

.takeout-tag {
  background: rgba(76, 113, 254, 0.1);
  color: #4c71fe;
  border: 1px solid #dbe3ff;
}

.integral-tag {
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  color: #67c23a;
}

.group-tag {
  background: #fdf6ec;
  border: 1px solid #faecd8;
  color: #eba93c;
}
</style>
